import { validateNorwegianIdNumber } from 'norwegian-national-id-validator';

export function validateNorwegianSSN(ssn: string) {
  if (!ssn) return false;

  // Bypass SSN validation with Query Param
  // Not sure who is using this at migration moment
  if (typeof window !== 'undefined') {
    if (
      new URLSearchParams(window.location.search).get('bypassNationalId') ===
      'true'
    ) {
      return true;
    }
  }

  return validateNorwegianIdNumber(ssn);
}
